import { createFileRoute } from "@tanstack/react-router"
import { useBudgetContext } from "~/context/BudgetProvider"
import BudgetSalesPricesView from "~/components/budget/BudgetSalesPricesView"
import { BudgetRevenueCalculationToolbar } from "~/components/budget/BudgetRevenueCalculation"
import { WorkspacePage } from "~/components/design-system/pages"
import ViewConfiguration from "~/components/planning/ViewConfiguration"
import { BUDGET_SALES_PRICES_TABLE_ID } from "~/constants"

export const Route = createFileRoute(
  "/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/sales-prices",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { variantIds, budget } = useBudgetContext()
  return (
    <WorkspacePage
      contentClassName="p-0"
      fillContent
      toolbar={<BudgetRevenueCalculationToolbar />}
      viewConfiguration={
        <ViewConfiguration
          tableId={BUDGET_SALES_PRICES_TABLE_ID}
          showFilters={false}
          showWarehouseSelect={false}
        />
      }
    >
      <BudgetSalesPricesView variantIds={variantIds} budget={budget} />
    </WorkspacePage>
  )
}
